import styled from 'styled-components/native';

export const ModuleWrapper = styled.View`
  padding-left: 16px;
  padding-right: 16px;
`;
